export const getTextInputContainerStyles = () => ({
  TextInputContainer: {
    width: '435px',
    '& div .error': {
      color: '#A80000',
    },
  },
});

export const getRemainingCharsStyles = () => ({
  RemainingCharsContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
});
